<div class="overlay" *ngIf="ShowEmailNotificationContainer || ShowInitializeRequestPickup || ShowTrackHistory || ShowTrackDetails || ShowShipmentsStatusUpdateContainer || ShowDeleteLabelQuestion || ShowForceQuestion;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteLabelQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteLabelQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteLabelQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteLabelQuestion = false;DeleteShippingLabel();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowForceQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowForceQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle" *ngIf="this.ShippingDetails.ForceClose != true;">
      {{ 'ForceShippingCloseQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody" *ngIf="this.ShippingDetails.ForceClose != true;">
      {{ 'ForceShippingCloseQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionTitle" *ngIf="this.ShippingDetails.ForceClose == true;">
        {{ 'UnForceShippingCloseQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody" *ngIf="this.ShippingDetails.ForceClose == true;">
        {{ 'UnForceShippingCloseQuestionDescription' | translate }}
      </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowForceQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowForceQuestion = false;ForceShipmentClose();" *ngIf="this.ShippingDetails.ForceClose != true;">{{ 'ForceShipmentClose' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowForceQuestion = false;ForceShipmentClose();" *ngIf="this.ShippingDetails.ForceClose == true;">{{ 'UnForceShipmentClose' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowInitializeRequestPickup">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowInitializeRequestPickup = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'InitializeRequestPickup' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'InitializeRequestPickupDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowInitializeRequestPickup = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowInitializeRequestPickup = false;RequestPickup();">{{ 'RequestPickup' | translate }}</button>
    </div>
</div>

<!-- ✅ Track History Popup - Minimalist Corporate Design -->
<div class="ShowTrackHistoryContainer animated fadeInDownBig" *ngIf="this.ShowTrackHistory == true">
    <!-- Close Button -->
    <div class="ShowTrackHistoryContainerCloseContainer">
        <i class="material-icons" (click)="this.ShowTrackHistory = false;">close</i>
    </div>

    <!-- Header: Tracking Number -->
    <div class="ShowTrackHistoryContainerTitle">
        <span><strong>{{'Tracking' | translate}}:</strong> {{this.ShippingDetails.TrackingLabel}}</span>
    </div>

    <!-- Header: Shipping Company -->
    <div class="ShowTrackHistoryContainerTitle">
        <span>{{'ShippingCompany' | translate}}:</span>
        <img [src]="this.parent.BackendServiceUrl + this.ShippingDetails.ShippingCompany.ImagePath"
             [alt]="this.ShippingDetails.ShippingCompany.Name">
    </div>

    <!-- Timeline Body -->
    <div class="ShowTrackHistoryContainerBody">
        <div *ngFor="let e of this.TrackEvents; let i=index; let isLast=last;"
             class="TrackEventContainer"
             [ngClass]="{ 'different-day': e.FirstEventOfTheDay }">

            <!-- Timestamp -->
            <div class="TrackEventContainerTime">
                <span>{{e.DateTimeUI}}</span>
            </div>

            <!-- Timeline Indicator -->
            <div class="TrackEventContainerArrow">
                <div class="TrackEventContainerArrowBody" *ngIf="!isLast"></div>
                <i *ngIf="e.Status.ID != 14" class="material-icons">fiber_manual_record</i>
                <i *ngIf="e.Status.ID == 14" class="material-icons" style="color: #32aa3a;">check_circle</i>
            </div>

            <!-- Event Content -->
            <div class="TrackEventContainerContent">
                <span>{{e.Event}}</span>
                <span *ngIf="e.Status.ID == 14" class="DeliveredStatus">{{e.Status.Name}}</span>
                <span *ngIf="e.Status.ID != 14" class="TranzitStatus">{{e.Status.Name}}</span>
            </div>
        </div>
    </div>

    <!-- Footer Commands -->
    <div class="ShowTrackHistoryContainerCommands">
        <button mat-raised-button color="primary" (click)="UpdateShippingDetailsTrackingStatus();">
            <i class="material-icons">check</i>
            <span>{{'AcceptAndSave' | translate}}</span>
        </button>
    </div>
</div>

<div class="ShowTrackHistoryContainer animated fadeInDownBig" *ngIf="this.ShowTrackDetails == true">
    <div class="ShowTrackHistoryContainerCloseContainer">
        <i class="material-icons" (click)="this.ShowTrackDetails = false;">close</i>
    </div>
    <div class="ShowTrackHistoryContainerMainTitle">
        <span>{{'Tracking' | translate}}: {{this.ShippingDetails.TrackingLabel}}</span>
    </div>
    <div class="ShowTrackHistoryContainerMainTitle">
        <span>{{'Weight' | translate}}: {{this.ShippingDetails.TotalWeight}} {{this.ShippingDetails.WeightType.Name}}</span>
    </div>

    <div class="ShowTrackHistoryContainerBody" style="border: none;">
        <p>{{'ShippingServiceType' | translate}}: {{this.ShippingDetails?.ShippingServiceType?.Name}}</p>
        <p>{{'ShippingResponsability' | translate}}: {{this.ShippingDetails.ShippingResponsability?.Name}}</p>
        <p *ngIf="this.ShippingDetails.PriceContainsVAT != true;">{{'Price' | translate}}: {{this.ShippingDetails.Price?.UIUnitPrice}} {{this.ShippingDetails.Price?.Currency?.Name}} ({{'ExcludingVAT' | translate}})</p>
        <p *ngIf="this.ShippingDetails.PriceContainsVAT == true;">{{'Price' | translate}}: {{this.ShippingDetails.Price?.UIVATUnitPrice}} {{this.ShippingDetails.Price?.Currency?.Name}} ({{'WithVAT' | translate}})</p>
        <p>{{'Boxes' | translate}}:</p>
        <p *ngFor="let box of this.ShippingDetails.Boxes; let i=index;">{{i+1}} - ({{box.Weight}}{{this.ShippingDetails.WeightType.Name}}) {{box.Length}}X{{box.Width}}X{{box.Height}}</p>
    
        <button mat-raised-button color="primary" class="DetailsButton" (click)="TrackShippingLabel(this.ShippingDetails.TrackingLabel, this.ShippingDetails.ShippingCompany);">
            <i class="material-icons">near_me</i>
            <span>{{ 'Track' | translate }}</span>
        </button>
        <button mat-raised-button color="primary" class="DetailsButton" (click)="CopyLabelShippingDetails();">
            <i class="material-icons">content_copy</i>
            <span>{{ 'Copy' | translate }}</span>
        </button>

        <button mat-raised-button color="primary" class="DetailsButton" (click)="PrintShippingLabel(this.ShippingDetails.TrackingLabel, this.ShippingDetails.ShippingCompany, this.ShippingDetails?.ID);">
            <i class="material-icons">local_print_shop</i>
            <span>{{ 'PrintDocument' | translate }}</span>
        </button>
    </div>

    <div class="ShowTrackHistoryContainerCommands">
        <button mat-raised-button color="primary" (click)="this.ShowTrackDetails = false;">
            <i class="material-icons">check</i>
            <span>{{'AcceptAndSave' | translate}}</span>
        </button>
    </div>
</div>

<div class="ShipmentsStatusUpdateContainer animated fadeInDownBig" *ngIf="ShowShipmentsStatusUpdateContainer">
    <div class="ShipmentsStatusUpdateContainerCloseContainer" (click)="this.ShowShipmentsStatusUpdateContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="ShipmentsStatusUpdateContainerHeadder">
        {{'ShipmentsStatusUpdateBulk' | translate}}
    </div>
    <div class="ShipmentsStatusUpdateContainerBody">
        <p>{{'ShipmentsStatusUpdateBulkDescription' | translate}}</p>

        <div class="ShippingCompany" [ngClass]="{'SelectedShippingCompany': TrackAllAtOnce == true}" (click)="TrackAllAtOnce = true;">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="TrackAllAtOnce == true;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="TrackAllAtOnce == false;">radio_button_off</i>
            </div>
            <div class="ShippingText">
                {{'TrackAllAtOnce' | translate}}
            </div>
        </div>
        <div class="ShippingCompany" [ngClass]="{'SelectedShippingCompany': TrackAllAtOnce == false}" (click)="TrackAllAtOnce = false;">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="TrackAllAtOnce == false;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="TrackAllAtOnce == true;">radio_button_off</i>
            </div>
            <div class="ShippingText">
                {{'NOTTrackAllAtOnce' | translate}}
            </div>
        </div>
    </div>
    <div class="ShipmentsStatusUpdateContainerCommands">
        <button mat-raised-button color="primary" class="ShipmentsStatusUpdateContainerCommandsButton" (click)="TrackShippingLabelsBulk();">
            <i class="material-icons">near_me</i>
            <span>{{'UpdateTrackings' | translate}}</span>
        </button>
    </div>
</div>

<div class="EmailNotificationContainer animated fadeInDown" *ngIf="ShowEmailNotificationContainer">
    <div class="ShipmentsStatusUpdateContainerCloseContainer" (click)="this.ShowEmailNotificationContainer = false;">
        <i class="material-icons">close</i>
    </div>

    <div class="InfoQuestionTitle">
        {{ 'ContactSupport' | translate }}
      </div>

    <div class="EmailNotificationBody">
        <p class="EmailNotificationBodyTitle">{{ 'SendingEmail' | translate }}:</p>

        <div class="MinimalistRadioOption" *ngFor="let e of this.SMTPEmails" (click)="SelectSMTPEmail(e);">
          <span>{{e.Email}}</span>
          <i class="material-icons" *ngIf="e.IsDefault == true;">radio_button_checked</i>
          <i class="material-icons" *ngIf="e.IsDefault == false;">radio_button_unchecked</i>
        </div>

        <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'SupportProblem' | translate }}:</p>

        <div class="MinimalistRadioOption" *ngFor="let s of this.SupportContacts" (click)="SelectSupportCategory(s);">
          <span>{{s.Category.Name}}</span>
          <i class="material-icons" *ngIf="s.Category.IsSelected == true;">radio_button_checked</i>
          <i class="material-icons" *ngIf="s.Category.IsSelected == false;">radio_button_unchecked</i>
        </div>

        <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'SendTo' | translate }}:</p>
        <div class="MinimalistChipContainer unSelectable">
            <div class="MinimalistChip" *ngFor="let e of this.CurrentSupportContact.Emails" (click)="e.IsSelected = !e.IsSelected;" [ngClass]="{'MinimalistChipSelected': e.IsSelected == true}">
                <span>{{e.Email}}</span>
                <i class="material-icons" *ngIf="e.IsSelected == true;">check_circle</i>
                <i class="material-icons" *ngIf="e.IsSelected == false;">cancel</i>
            </div>
        </div>

        <div class="MinimalistInputContainer" style="margin-top: 20px;">
            <label class="MinimalistInputLabel">{{ 'Subject' | translate }}</label>
            <input autocomplete="off" [(ngModel)]="this.CurrentSupportContact.Subject" class="MinimalistInput" type="text">
        </div>

        <div class="MinimalistInputContainer" style="margin-top: 20px;">
            <label class="MinimalistInputLabel">{{ 'YourMessage' | translate }}</label>
            <textarea autocomplete="off" [(ngModel)]="this.CurrentSupportContact.Body" class="MinimalistTextarea" rows="15"></textarea>
        </div>
    </div>

    <div class="EmailNotificationCommands" style="margin-top: 25px;">
        <div [class.disabled]="this.parent.loading" class="MinimalistButton MinimalistButtonWarn" (click)="!this.parent.loading && (this.ShowEmailNotificationContainer = false);">
            <i class="material-icons">close</i>
            <span>{{ 'Cancel' | translate }}</span>
          </div>
        <div [class.disabled]="this.parent.loading" class="MinimalistButton MinimalistButtonPrimary" (click)="!this.parent.loading && SendContactSupportEmail();">
          <i class="material-icons">email</i>
          <span>{{ 'SendEmailNotification' | translate }}</span>
        </div>
      </div>
</div>

<div class="ShippingMainContent">
      <div class="HalfContentTitle">
          <p>{{'Shipments' | translate}}</p>

          <!-- Google-style Search Box -->
          <div class="GoogleSearchBox">
            <i class="material-icons search-icon" *ngIf="!MainSearchTerm || MainSearchTerm.length === 0">search</i>
            <i class="material-icons clear-icon" *ngIf="MainSearchTerm && MainSearchTerm.length > 0" (click)="ClearMainSearch()">close</i>
            <input
              type="text"
              class="GoogleSearchInput"
              placeholder="{{'Search' | translate}}..."
              autocomplete="off"
              [(ngModel)]="MainSearchTerm"
              (ngModelChange)="mainSearchTermUpdate.next($event)"
            />
          </div>

          <div class="TitleButton noselect" (click)="NewLabel();">
            <i class="material-icons">add</i>
            <span class="DottedRow">{{'NewShipment' | translate}}</span>
          </div>

          <div class="TitleButton noselect" (click)="PrepareShipmentsStatusUpdate();">
            <i class="material-icons">play_circle_outline</i>
            <span class="DottedRow">{{'UpdateTrackingStatus' | translate}}</span>
          </div>
      </div>

      <div class="FilterHeadder">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter; InitializeCompanies();">
            <i class="material-icons">filter_alt</i>
            <span>{{'Filter' | translate}}</span>
        </div>

        <div class="FilterButton noselect" (click)="LoadShipments();">
            <i class="material-icons">visibility</i>
            <span>{{'ViewShipments' | translate}}</span>
        </div>

        <div class="DirectionTabsWrapper">
            <div class="DirectionTab noselect" (click)="this.Filter?.ShippingDirection?.ID != 1 && SwitchDirection();" [ngClass]="{'SelectedDirectionTab ExportColor': this.Filter?.ShippingDirection?.ID == 1}">
                <i class="material-icons">flight_takeoff</i>
                <span>{{'Export' | translate}}</span>
            </div>
            <div class="DirectionTab noselect" (click)="this.Filter?.ShippingDirection?.ID != -1 && SwitchDirection();" [ngClass]="{'SelectedDirectionTab ImportColor': this.Filter?.ShippingDirection?.ID == -1}">
                <i class="material-icons">flight_land</i>
                <span>{{'Import' | translate}}</span>
            </div>
        </div>

        <div class="ActiveFilters">
            <div class="ActiveFilter" *ngFor="let a of activeFilters" (click)="RemoveActiveFilter(a.ID, a.Type);">
                <i class="material-icons">close</i>
                <span>{{a.Name}}</span>
            </div>
        </div>

        <div class="PagerContainer">
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; LoadShipments();">
                <i class="material-icons">chevron_right</i>
            </div>
            <div class="PagerTextContainer">
                <input class="PagerText" type="text" autocomplete="off" [(ngModel)]="this.Filter.Pager.PageSize" (change)="LoadShipments();">
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; LoadShipments();">
                <i class="material-icons">chevron_left</i>
            </div>
            <div class="PagerButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
            </div>
            <div class="PagerDescription">
                {{this.Shipments?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Shipments' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})
            </div>
        </div>

        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>

            <div class="FilterContainerBody">
                <!-- Row 1: Partner + Shipping Company -->
                <div class="FilterDropdownRow">
                    <!-- Partner Dropdown (Custom Style with Search) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showPartnerDropdown" (click)="showPartnerDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showPartnerDropdown = !showPartnerDropdown; InitializePartners();">
                            <span class="dropdown-label">{{ 'ChoosePartner' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">business</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.Partner?.Name"
                                [value]="this.Filter.Partner?.Name || ('ChoosePartner' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showPartnerDropdown">
                            <!-- Search Input -->
                            <div style="padding: 8px; border-bottom: 1px solid #f0f4f8;">
                                <input
                                    type="text"
                                    placeholder="{{ 'Search' | translate }}..."
                                    [(ngModel)]="this.FilterPartnerSearchTerm"
                                    (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                                    style="width: 100%; padding: 6px 10px; border: 1px solid #d0e0f5; border-radius: 4px; font-size: 11px; outline: none;"
                                />
                            </div>
                            <div class="CustomDropdownResult"
                                 *ngFor="let p of Partners"
                                 (click)="this.Filter.Partner = p; AddActiveFilter(p.Name, 'Partner'); showPartnerDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{p.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Shipping Company Dropdown (Custom Style) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showShippingCompanyDropdown = !showShippingCompanyDropdown;">
                            <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">local_shipping</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.ShippingCompany?.Name"
                                [value]="this.Filter.ShippingCompany?.Name || ('ShippingCompany' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdown">
                            <div class="CustomDropdownResult"
                                 *ngFor="let s of this.ShippingCompanies"
                                 (click)="this.Filter.ShippingCompany = s; AddActiveFilter(s.Name, 'ShippingCompany'); showShippingCompanyDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <img *ngIf="s.ImagePath" [src]="this.parent.BackendServiceUrl + s.ImagePath" style="width: 20px; height: 20px; object-fit: contain;">
                                    <span class="CustomDropdownResultText">{{s.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Row 2: Company + Shipping Service Type -->
                <div class="FilterDropdownRow">
                    <!-- Company Dropdown (Custom Style) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showCompanyDropdown" (click)="showCompanyDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showCompanyDropdown = !showCompanyDropdown;">
                            <span class="dropdown-label">{{ 'Company' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">domain</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.Company?.Name"
                                [value]="this.Filter.Company?.Name || ('Company' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showCompanyDropdown">
                            <div class="CustomDropdownResult"
                                 *ngFor="let c of this.Companies"
                                 (click)="this.Filter.Company = c; AddActiveFilter(c.Name, 'Company'); showCompanyDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{c.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Shipping Service Type Dropdown (Custom Style) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown;">
                            <span class="dropdown-label">{{ 'ShippingServiceType' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">speed</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.ShippingServiceType?.Name"
                                [value]="this.Filter.ShippingServiceType?.Name || ('ShippingServiceType' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdown">
                            <div class="CustomDropdownResult"
                                 *ngFor="let t of this.ShippingServiceTypes"
                                 (click)="this.Filter.ShippingServiceType = t; AddActiveFilter(t.Name, 'ShippingServiceType'); showShippingServiceTypeDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{t.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Row 3: Shipping Direction + Tracking Status -->
                <div class="FilterDropdownRow">
                    <!-- Shipping Direction Dropdown (Custom Style) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showShippingDirectionDropdown" (click)="showShippingDirectionDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showShippingDirectionDropdown = !showShippingDirectionDropdown;">
                            <span class="dropdown-label">{{ 'ShippingDirection' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">swap_horiz</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.ShippingDirection?.Name"
                                [value]="this.Filter.ShippingDirection?.Name || ('ShippingDirection' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showShippingDirectionDropdown">
                            <div class="CustomDropdownResult"
                                 *ngFor="let c of this.Directions"
                                 (click)="this.Filter.ShippingDirection = c; showShippingDirectionDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{c.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tracking Status Dropdown (Custom Style with Search) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showTrackingStatusDropdown" (click)="showTrackingStatusDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showTrackingStatusDropdown = !showTrackingStatusDropdown; InitializeTrackingStatus();">
                            <span class="dropdown-label">{{ 'TrackingStatus' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">track_changes</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.TrackingStatus?.Name"
                                [value]="this.Filter.TrackingStatus?.Name || ('TrackingStatus' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showTrackingStatusDropdown">
                            <!-- Search Input -->
                            <div style="padding: 8px; border-bottom: 1px solid #f0f4f8;">
                                <input
                                    type="text"
                                    placeholder="{{ 'Search' | translate }}..."
                                    [(ngModel)]="this.FilterTrackingStatus"
                                    (ngModelChange)="this.trackingStatusSearchTermUpdate.next($event)"
                                    style="width: 100%; padding: 6px 10px; border: 1px solid #d0e0f5; border-radius: 4px; font-size: 11px; outline: none;"
                                />
                            </div>
                            <div class="CustomDropdownResult"
                                 *ngFor="let t of TrackingStatuses"
                                 (click)="this.Filter.TrackingStatus = t; AddActiveFilter(t.Name, 'TrackingStatus'); showTrackingStatusDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{t.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Row 4: Shipping Cost Status + Country -->
                <div class="FilterDropdownRow">
                    <!-- Shipping Cost Status Dropdown (Custom Style) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showShippingCostStatusDropdown" (click)="showShippingCostStatusDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showShippingCostStatusDropdown = !showShippingCostStatusDropdown;">
                            <span class="dropdown-label">{{ 'ShippingCostStatus' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">attach_money</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.CostStatus?.Name"
                                [value]="this.Filter.CostStatus?.Name || ('ShippingCostStatus' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showShippingCostStatusDropdown">
                            <div class="CustomDropdownResult"
                                 *ngFor="let s of this.ShippingCostStatuses"
                                 (click)="this.Filter.CostStatus = s; showShippingCostStatusDropdown = false;">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{s.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Country Dropdown (Custom Style with Search) -->
                    <div class="CustomDropdownContainer">
                        <div class="DropdownOverlayTransparent" *ngIf="showCountryDropdown" (click)="showCountryDropdown = false"></div>

                        <div class="CustomDropdownBar" (click)="showCountryDropdown = !showCountryDropdown;">
                            <span class="dropdown-label">{{ 'Country' | translate }}</span>
                            <i class="material-icons dropdown-icon-left">public</i>
                            <input
                                type="text"
                                class="CustomDropdownInput"
                                [class.placeholder]="!this.Filter.Country?.Name"
                                [value]="this.Filter.Country?.Name || ('Country' | translate)"
                                readonly
                            />
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>

                        <div class="CustomDropdownResults" *ngIf="showCountryDropdown">
                            <!-- Search Input -->
                            <div style="padding: 8px; border-bottom: 1px solid #f0f4f8;">
                                <input
                                    type="text"
                                    placeholder="{{ 'Search' | translate }}..."
                                    [(ngModel)]="FilterCountrySearchTerm"
                                    style="width: 100%; padding: 6px 10px; border: 1px solid #d0e0f5; border-radius: 4px; font-size: 11px; outline: none;"
                                />
                            </div>
                            <div class="CustomDropdownResult"
                                 *ngFor="let c of FilteredCountries"
                                 (click)="this.Filter.Country = c; AddActiveFilter(c.Name, 'Country'); showCountryDropdown = false; FilterCountrySearchTerm = '';">
                                <div class="CustomDropdownResultMain">
                                    <span class="CustomDropdownResultText">{{c.Name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="FilterCommands">
                <div class="FilterButtonAction" (click)="LoadShipments();">
                    <i class="material-icons">filter_list</i>
                    <span>{{ 'Filter' | translate }}</span>
                </div>
            </div>
        </div>
      </div>

      <div class="TableMasterContainer">
        <div class="ShippingTableRow ShippingTableHeadder">
            <div class="ShippingTableCol">
                <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
            </div>
            <div class="ShippingTableCol">#</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'EventRegister' | translate}}</div>
            <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">{{'From' | translate}}</div>
            <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">{{'To' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Tracking' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'ShippingCompany' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 5%;">{{'ShippingServiceType' | translate}}</div>
            <div class="ShippingTableCol DottedRow textRight" style="width: 10%;">{{'ShippingCost' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Status' | translate}}</div>
            <div class="ShippingTableCol DottedRow" style="width: 10%;">{{'Actions' | translate}}</div>
        </div>

        <div class="ShippingTableRow" *ngFor="let s of this.Shipments; let i=index;">
            <div class="ShippingTableRowHead" (dblclick)="ShowShipmentDetails(s);">
                <div class="ShippingTableCol" style="padding-top: 7px;">
                    <mat-checkbox class="tableColCheckBox" [(ngModel)]="s.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                </div>
                <div class="ShippingTableCol"><span>{{i+1}}</span></div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <span>{{s.EventRegisterUI}}</span>
                    <span *ngIf="s.CostStatus?.ID == 2;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                    <span style="background: gold;" *ngIf="s.CostStatus?.ID == 1;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                    <span style="background: #fd4f57" *ngIf="s.CostStatus?.ID == -1;" class="CostStatusDot" matTooltip="{{s.CostStatus?.Name}}" matTooltipClass='neutral-tool-tip-management'></span>
                </div>
                <div class="ShippingTableCol  textLeft" style="width: 15%;"><span>{{s.Sender?.ContactCompany}}</span></div>
                <div class="ShippingTableCol  textLeft" style="width: 15%;"><span>{{s.Receiver?.ContactCompany}}</span></div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <span style="margin: 0;">{{s.TrackingLabel}}</span>
                    <span class="ShippingTableColDescription">{{s.Boxes.length}} {{'Boxes' | translate}} ({{s.TotalWeight}} {{s.WeightType.Name}})</span>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <img [src]="this.parent.BackendServiceUrl + s.ShippingCompany.ImagePath">
                    <i class="material-icons shippingServiceIcon" style="color: #0082e6;" *ngIf="s.ShippingServiceType?.ID == -1;">local_shipping</i>
                    <i class="material-icons shippingServiceIcon" style="color: #32aa3a;" *ngIf="s.ShippingServiceType?.ID == 1;">flight_takeoff</i>
                </div>
                <div class="ShippingTableCol" style="width: 5%;">
                    <span style="margin: 0;">{{s.ShippingServiceType?.Name}}</span>
                    <span class="ShippingTableColDescription">({{s.ShippingDirection?.Name}})</span>
                    <i class="material-icons shippingDirectionIcon" style="color: #32aa3a;" *ngIf="s.ShippingDirection?.ID == 1;">north_east</i>
                    <i class="material-icons shippingDirectionIcon" style="color: #0082e6;" *ngIf="s.ShippingDirection?.ID == -1;">south_east</i>
                </div>
                <div class="ShippingTableCol  textRight" style="width: 10%;">
                    <span style="margin: 0;" *ngIf="s.PriceContainsVAT != true;">{{s.Price?.UIUnitPrice}} {{s.Price?.Currency?.Name}}</span>
                    <span style="margin: 0;" *ngIf="s.PriceContainsVAT == true;">{{s.Price?.UIVATUnitPrice}} {{s.Price?.Currency?.Name}}</span>
                    <span class="ShippingTableColDescription" *ngIf="s.PriceContainsVAT != true && s.Price != null;">({{'ExcludingVAT' | translate}})</span>
                    <span class="ShippingTableColDescription" *ngIf="s.PriceContainsVAT == true && s.Price != null;">({{'WithVAT' | translate}})</span>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    <p *ngIf="s.Status?.ID != null;" class="StatusSpan" [ngClass]="{'White': s.Status?.Color?.ID == 0, 'Black': s.Status?.Color?.ID == 1, 'Blue': s.Status?.Color?.ID == 2, 'LightBlue': s.Status?.Color?.ID == 3, 'DarkBlue': s.Status?.Color?.ID == 4
                    , 'Red': s.Status?.Color?.ID == 5, 'LightRed': s.Status?.Color?.ID == 6, 'DarkRed': s.Status?.Color?.ID == 7, 'Green': s.Status?.Color?.ID == 8
                    , 'LightGreen': s.Status?.Color?.ID == 9, 'DarkGreen': s.Status?.Color?.ID == 10
                    , 'Yellow': s.Status?.Color?.ID == 11, 'Orange': s.Status?.Color?.ID == 12
                    , 'Purple': s.Status?.Color?.ID == 13, 'WhiteText': s.Status?.Color?.WhiteText == true}"
                    (dblclick)="TrackShippingLabel(s);">
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 0">question_mark</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 11">question_mark</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 3 && s.ShippingServiceType?.ID == 1;">flight</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 3 && s.ShippingServiceType?.ID == -1;">local_shipping</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 8">check</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 9">delivery_dining</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 2">how_to_reg</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 13">person_off</i>
                    <i class="material-icons" *ngIf="s.Status?.Color?.ID == 5 || s.Status?.Color?.ID == 6 || s.Status?.Color?.ID == 7 || s.Status?.Color?.ID == 12">warning_amber</i>
                    <span>{{s.Status?.Name}}</span>
                    </p>
    
                    <p *ngIf="s.ForceClose == true;" class="ForceStatusSign" matTooltip="{{ 'ForcedShipment' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                        <i class="material-icons">warning_amber</i>
                    </p>
                </div>
                <div class="ShippingTableCol" style="width: 10%;">
                    
                </div>
            </div>
            <div class="ShippingTableRowBody" *ngIf="s.ShowDetails == true" [ngClass]="{'open': s.ShowDetails}">
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingFromGrid == true;"></mat-spinner>

                <div *ngIf="this.GridShippingDetails != null;">
                    <div class="ShippingTableCol DottedRow" style="width: 15%;">
                        <div class="ShippingRowActionButton noselect" (click)="PrintShippingLabel(s.TrackingLabel, s.ShippingCompany, s.ShippingDetailsID);">
                            <i class="material-icons">local_print_shop</i>
                            <span>{{ 'PrintDocument' | translate }}</span>
                         </div>
                         <div class="ShippingRowActionButton noselect" (click)="CopyLabel(s);">
                            <i class="material-icons">content_copy</i>
                            <span>{{ 'Copy' | translate }}</span>
                         </div>
                         <div class="ShippingRowActionButton noselect" *ngIf="s.AccountingDocumentID?.length > 0;" (click)="this.parent.GoToDocumentPage(s.AccountingDocumentID, s.ShippingDirection?.ID, s.CompanyID);">
                            <i class="material-icons">linear_scale</i>
                            <span>{{s.AccountingNumberDisplayValue}}</span>
                         </div>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.ContactPerson}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.VATNumber}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.Country.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.State}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.City}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.AddressLine}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.ZipCode}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Sender.Phone}}</div>
                        </div>

                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'Boxes' | translate}}:</div>
                        </div>
                        <div class="ShippingTableColParagraph" *ngFor="let box of this.GridShippingDetails.Boxes; let y=index;">
                            <div class="ShippingTableColParagraphValue">
                                {{y + 1}} - ({{box.Weight}}{{this.GridShippingDetails?.WeightType?.Name}}) {{box.Length}}X{{box.Width}}X{{box.Height}}
                            </div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'Total' | translate}}: {{this.GridShippingDetails.TotalWeight}} {{this.GridShippingDetails?.WeightType?.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">
                                <i class="material-icons" style="color: #0082e6;" *ngIf="s.ShippingServiceType?.ID == -1;">local_shipping</i>
                                <i class="material-icons" style="color: #32aa3a;" *ngIf="s.ShippingServiceType?.ID == 1;">flight_takeoff</i>
                            </div>
                        </div>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 15%;">
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.ContactPerson}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.VATNumber}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.Country.Name}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.State}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.City}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.AddressLine}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.ZipCode}}</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{GridShippingDetails.Receiver.Phone}}</div>
                        </div>

                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue">{{'ShippingCost' | translate}}:</div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Aquisition' | translate}}:</span> <span>{{GridShippingDetails?.Statistics?.Cost?.BuyPrice?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.BuyPrice?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Sale' | translate}}:</span> <span>{{GridShippingDetails?.Statistics?.Cost?.SellPrice?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.SellPrice?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Profit' | translate}}:</span> <span [ngClass]="{'Profitable': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2, 'Neutral': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 1, 'Loss': GridShippingDetails?.Statistics?.Cost?.Status?.ID == -1}"><span *ngIf="GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2">+</span>{{GridShippingDetails?.Statistics?.Cost?.Profit?.UIUnitPrice}} {{GridShippingDetails?.Statistics?.Cost?.Profit?.Currency?.Name}}</span></div>
                        </div>
                        <div class="ShippingTableColParagraph">
                            <div class="ShippingTableColParagraphValue"><span>{{'Status' | translate}}:</span> <span [ngClass]="{'Profitable': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 2, 'Neutral': GridShippingDetails?.Statistics?.Cost?.Status?.ID == 1, 'Loss': GridShippingDetails?.Statistics?.Cost?.Status?.ID == -1}">{{GridShippingDetails?.Statistics?.Cost?.Status?.Name}}</span></div>
                        </div>
                    </div>
                    <div class="ShippingTableCol DottedRow textLeft" style="width: 35%;padding-left: 2.5%; padding-right: 2.5%;">

                        <div class="ShippingLogTabsWrapper">
                            <div class="ShippingLogTab" (click)="SelectShippingLog();" [ngClass]="{'SelectedShippingLogTab': this.ShowShippingLog == true}">
                                <i class="material-icons">receipt_long</i>
                                <span>{{'ShippingLog' | translate}}</span>
                            </div>
                            <div class="ShippingLogTab" (click)="SelectTrackingLog(s);" [ngClass]="{'SelectedShippingLogTab': this.ShowTrackingLog == true}">
                                <i class="material-icons">timeline</i>
                                <span>{{'TrackHistory' | translate}}</span>
                            </div>
                        </div>

                        <mat-spinner class="smallSpinnerTrackEvents" [diameter]="30" *ngIf="this.trackEventsLoading == true;"></mat-spinner>

                        <!-- Track History Log -->
                        <div class="LogResultsContainer" *ngIf="this.ShowTrackingLog == true && this.TrackEvents?.length > 0;">
                            <div class="LogEventRow" *ngFor="let e of this.TrackEvents; let x=index;"
                                 [ngClass]="{'LogWhite': e.Status?.Color?.ID == 0, 'LogBlack': e.Status?.Color?.ID == 1, 'LogBlue': e.Status?.Color?.ID == 2, 'LogLightBlue': e.Status?.Color?.ID == 3, 'LogDarkBlue': e.Status?.Color?.ID == 4, 'LogRed': e.Status?.Color?.ID == 5, 'LogLightRed': e.Status?.Color?.ID == 6, 'LogDarkRed': e.Status?.Color?.ID == 7, 'LogGreen': e.Status?.Color?.ID == 8, 'LogLightGreen': e.Status?.Color?.ID == 9, 'LogDarkGreen': e.Status?.Color?.ID == 10, 'LogYellow': e.Status?.Color?.ID == 11, 'LogOrange': e.Status?.Color?.ID == 12, 'LogPurple': e.Status?.Color?.ID == 13, 'LogWhiteText': e.Status?.Color?.WhiteText == true}">
                                <div class="LogEventIndex">{{x + 1}}</div>
                                <div class="LogEventDate">{{e.DateTimeUI}}</div>
                                <div class="LogEventName">{{e.Status?.Name}}</div>
                            </div>
                        </div>

                        <!-- Shipping Log -->
                        <div class="LogResultsContainer" *ngIf="this.ShowShippingLog == true && this.GridShippingDetails.ShippingLog?.length > 0;">
                            <div class="LogEventRow" *ngFor="let log of this.GridShippingDetails.ShippingLog; let x=index;">
                                <div class="LogEventIndex">{{x + 1}}</div>
                                <div class="LogEventDate">{{log.EventRegisterUI}}</div>
                                <div class="LogEventName">{{log.EventType?.Name}}</div>
                            </div>
                            <div class="LogEventRow LogEventRowSecondary" *ngFor="let log of this.GridShippingDetails.ShippingLog; let x=index;">
                                <div class="LogEventIndex" *ngIf="log.AssociatedUser?.Id?.length > 0;"></div>
                                <div class="LogEventDate" *ngIf="log.AssociatedUser?.Id?.length > 0;"></div>
                                <div class="LogEventName" *ngIf="log.AssociatedUser?.Id?.length > 0;">{{log.AssociatedUser?.Email}}</div>
                            </div>
                        </div>

                    </div>
                    <div class="ShippingTableCol DottedRow" style="width: 20%;">
                     <div class="ShippingRowActionButton noselect" (click)="GetShippingDetails(s.ShippingDetailsID, s.ShippingDirection.ID);">
                        <i class="material-icons">image_search</i>
                        <span>{{ 'Details' | translate }}</span>
                     </div>
                     <div class="ShippingRowActionButton noselect" (click)="TrackShippingLabel(s);">
                        <i class="material-icons">near_me</i>
                        <span>{{ 'Track' | translate }}</span>
                     </div>
                     <div class="ShippingRowActionButton noselect" *ngIf="s.ShippingDirection.ID != 1 && s.Status?.ID < 0;" (click)="GetShippingDetailsForPickup(s.ShippingDetailsID, s.ShippingDirection.ID); InitializeRequestPickup(s);">
                        <i class="material-icons">group_add</i>
                        <span>{{ 'RequestPickup' | translate }}</span>
                     </div>
                     <div class="ShippingRowActionButton noselect" (click)="GetShippingCompanySupportEmailData(s); GetAttachments(s.TrackingLabel, s.ShippingCompany);">
                        <i class="material-icons">computer</i>
                        <span>{{ 'ContactSupport' | translate }}</span>
                     </div>

                     <div class="ShippingRowActionButton noselect" (click)="GetShippingDetailsForDeleteRequest(s.ShippingDetailsID, s.ShippingDirection.ID);">
                        <i class="material-icons">cancel</i>
                        <span>{{ 'RequestCancellation' | translate }}</span>
                     </div>
                     <div class="ShippingRowActionButton noselect" (click)="OpenForceQuestion(s);">
                        <i class="material-icons">autorenew</i>
                        <span *ngIf="s.ForceClose != true;">{{ 'ForceShipmentClose' | translate }}</span>
                        <span *ngIf="s.ForceClose == true;">{{ 'UnForceShipmentClose' | translate }}</span>
                     </div>
                    </div>
              </div>
            </div>
        </div>
      </div>
</div>